/**
 * Builds a partial payload for POST /merchant/restaurant/update.
 *
 * Only `restaurantId` and the provided `overrides` are sent so an edit to one
 * field does not rewrite unrelated restaurant data.
 */
export const buildRestaurantUpdatePayload = ({ restaurantId, detail = {}, overrides = {} }) => {
  const raw = detail?.raw ?? {};

  return {
    restaurantId: String(restaurantId ?? detail?.id ?? raw.restaurantId ?? raw.id ?? ''),
    ...overrides,
  };
};

/**
 * Returns only the keys in `next` whose values differ from `baseline`.
 * Uses JSON string compare so arrays/objects (e.g. operatingHours) work.
 * Returns `null` when nothing changed.
 */
export const pickChangedFields = (next = {}, baseline = {}) => {
  const changed = {};

  Object.keys(next).forEach((key) => {
    const nextValue = next[key];
    const baselineValue = baseline[key];

    if (JSON.stringify(nextValue) !== JSON.stringify(baselineValue)) {
      changed[key] = nextValue;
    }
  });

  return Object.keys(changed).length > 0 ? changed : null;
};

export default buildRestaurantUpdatePayload;
